module.exports = __webpack_public_path__ + "img/account-faq.fa169bd4.svg";